import React from 'react';
import styles from './styles/Page.module.css';

export default function TermsFrench() {
  return (
    <>
      <div className={styles.page}>
        <h1 className={styles.page_title}>CONDITIONS GENERALES D’UTILISATION ET DE SERVICES</h1>
        <div className={styles.date}>Version en date du 21/09/2023</div>

        <p className={styles.title}>
          <strong>
            1. Définitions
          </strong>
        </p>

        <div className={styles.table}>
          <div className={styles.row}>
            <div className={styles.left}>Actifs</div>
            <div className={styles.right}>
              désignent les informations et documents, de quelque nature que ce soit, qui sont détenus et déposés de manière chiffrée par le Client sur son Compte Client.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Application OSTREON ou Application
            </div>
            <div className={styles.right}>
              désigne le logiciel en mode SaaS, permettant l’envoi, et le cas échéant la transmission, de manière automatisée et sécurisée, des Actifs sélectionnés par le Client, selon des critères choisis et aux Bénéficiaires définis unilatéralement par le Client.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Bénéficiaire(s)</div>
            <div className={styles.right}>
              désigne(nt) les personnes physiques, de plus de 18 ans et capables, désignées par le Client depuis son Compte Client, susceptibles d’accéder aux Actifs du Client.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>CG ou Conditions Générales</div>
            <div className={styles.right}>
              désignent les présentes conditions générales d’utilisation et de services.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Client</div>
            <div className={styles.right}>
              désigne toute personne physique majeure ayant la capacité de contracter ou toute personne morale, représentée par une personne physique ayant la capacité de la représenter et de l’engager, qui souscrit à un abonnement aux fins de bénéficier des Services d’OSTREON à des fins non professionnelles, ou bénéficiant  d’une Offre d’essai.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Compte Client
            </div>
            <div className={styles.right}>
              désigne le compte que tout Utilisateur doit créer aux fins de pouvoir bénéficier des Services fournis par OSTREON ou souscrire à un abonnement. Le Compte Client peut également être désigné comme le compte utilisateur ou le compte sur l’Application OSTREON.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Données Personnelles</div>
            <div className={styles.right}>
              désignent les données à caractère personnel telles que définies à l’article 4.1 du Règlement général sur la protection des données ou « RGPD ».
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Facilitateur</div>
            <div className={styles.right}>
              désigne toute personne physique ou morale que le Client peut désigner de manière facultative en raison de ses connaissances sur les Actifs aux fins qu’il fournisse une aide aux Bénéficiaires en cas de besoin.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Informations confidentielles
            </div>
            <div className={styles.right}>
              désigne toute information, sous quelque forme et de quelque nature qu’elle soit, protégeable ou non, auxquelles les Parties auraient accès à l’occasion de l’exécution des présentes et qui ne seraient pas tombés dans le domaine public, sauf autorisation préalable et expresse de l’autre Partie.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Notifications
            </div>
            <div className={styles.right}>
              désignent les messages envoyés par OSTREON, que ce soit aux Clients, aux Bénéficiaires et éventuellement aux Facilitateurs.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Offre d’essai
            </div>
            <div className={styles.right}>
              désigne l’offre proposée par OSTREON donnant accès, de manière gratuite et pour une durée limitée, aux Services fournis par OSTREON.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              OSTREON
            </div>
            <div className={styles.right}>
              désigne la société Ostreon Cybersecurity, société par actions simplifiée au capital de 5.000 €, immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le numéro 920 541 448, dont le siège social est situé au 13 T rue Auguste Gervais 92130 Issy-les-Moulineaux.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Politique de confidentialité
            </div>
            <div className={styles.right}>
              désigne la politique de confidentialité d’OSTREON accessible à l’url suivante: <a href="https://ostreon.io/privacy-policy/fr">https://ostreon.io/privacy-policy/fr</a>.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>Services</div>
            <div className={styles.right}>
              désignent les prestations de services fournies par OSTREON, dans le cadre de l’Application, telles que décrites à l’article « Les Services fournis par OSTREON ».
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Site
            </div>
            <div className={styles.right}>
              désigne le site internet d’OSTREON accessible à l’url Eu.ostreon.io ou à toute autre url qui viendrait se substituer à cette dernière.
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.left}>
              Utilisateur
            </div>
            <div className={styles.right}>
              désigne toute personne physique ou morale naviguant sur le Site, en ce inclus les Bénéficiaires.
            </div>
          </div>
        </div>

        <p className={styles.title}>
          <strong>
            2. Le Site
          </strong>
        </p>

        <p>
          Le Site édité et exploité par OSTREON a pour objet de fournir à l’Utilisateur des informations sur les activités et sur les Services proposés par OSTREON, ainsi que d’accéder aux Services fournis par OSTREON.
        </p>

        <p className={styles.title}>
          <strong>
            3. Objet et Champ d’application des CG
          </strong>
        </p>

        <p>
          Les présentes CG régissent, à l’exclusion de tout autre document, les relations entre OSTREON et:
          <ul>
            <li>
              les Utilisateurs du Site;
            </li>
            <li>
              les Clients ayant souscrit aux Services d’OSTREON, bénéficiant ou non d’une Offre d’Essai.
            </li>
          </ul>
        </p>

        <p>
          OSTREON se réserve la faculté de modifier ses CG à tout moment. Les CG applicables sont celles en vigueur à la date où l’Utilisateur navigue sur le Site et/ou l’Utilisateur souscrit aux Services d’OSTREON.
        </p>
        <p>
          Les CG sont mises à la disposition de tout Utilisateur en bas de page du Site où elles sont directement consultables à tout moment. Tout Utilisateur dispose de la faculté de sauvegarder et d'imprimer les CG en utilisant les fonctionnalités standards de son navigateur ou de son ordinateur.
        </p>
        <p>
          Avant de souscrire aux Services d’OSTREON, l’Utilisateur est invité à prendre connaissance des CG et à les accepter sans réserve. Cette acceptation des CG, formalisée par un clic de validation, confère une valeur contractuelle électronique aux CG et emporte adhésion et acceptation pleine et entière des CG.
        </p>
        <p>
          Les CG sont rédigées en langue française. Dans le cas où elles seraient traduites en une ou plusieurs langues étrangères, seul le texte français ferait foi en cas de litige.
        </p>
        <p>
          OSTREON met à la disposition des Utilisateurs, en complément des présentes CG, des guides d’utilisation aux fins de fournir aux Utilisateurs plus de détails sur le fonctionnement des Services. Ces guides sont accessibles à l’url suivante: <a href="https://ostreon.io/help-center">https://ostreon.io/help-center</a>.
        </p>

        <p className={styles.title}>
          <strong>
            4. Accès au Site
          </strong>
        </p>

        <p>
          Le Site est accessible à titre gratuit et à toute personne disposant d’un accès à Internet depuis les terminaux suivants : ordinateur, tablette ou smartphone.
        </p>
        <p>
          L’Utilisateur s’assure que la configuration informatique utilisée ne contient aucun virus, qu’elle est en bon état de fonctionnement et que son navigateur permet un accès sécurisé au Site.
        </p>
        <p>
          L’Utilisateur conserve à sa charge le coût de l’utilisation de la technique de communication à distance utilisée et de ses moyens d’accès.
        </p>
        <p>
          OSTREON ne peut garantir un fonctionnement ininterrompu et exempt de toute erreur du Site et/ou de l’Application. De même, la responsabilité d’OSTREON ne saurait être engagée pour des pannes et des problèmes d’ordre technique concernant le matériel, les programmes et logiciels ou le réseau Internet, à l’origine de dysfonctionnements et/ou de l’interruption définitive ou momentanée du Site et/ou de l’Application.
        </p>
        <p>
          OSTREON se réserve la possibilité, à sa seule discrétion, avec ou sans préavis, de suspendre, interrompre ou de limiter l’accès à tout ou partie du Site et/ou de l’Application, notamment à des fins de mise à jour.
        </p>
        <p>
          En cas de difficultés d’accès, l’Utilisateur peut envoyer une demande d’assistance à l’adresse suivante: <a href="mailto:support@ostreon.io">support@ostreon.io</a>. OSTREON s’engage à fournir une réponse à cette demande dans un délai de quarante-huit (48) heures pendant les heures de travail, à savoir du lundi au vendredi de 9h à 18h (France).
        </p>

        <p className={styles.title}>
          <strong>
            5. Utilisation du Site
          </strong>
        </p>

        <p>
          L’Utilisateur s’engage à utiliser le Site pour son usage personnel, conformément aux dispositions figurant dans les CG et au droit applicable.
        </p>
        <p>
          L’Utilisateur s’abstient: <br />
          <ul>
            <li>
              d’utiliser le Site, l’Application et les Services de manière abusive ou frauduleuse, notamment pour l’exercice d’activités illégales ou portant atteinte aux droits ou à la sécurité des tiers;
            </li>
            <li>
              de réaliser des actions ou actes susceptibles de porter atteinte à l’ordre public ou de violer des lois et règlements en vigueur;
            </li>
            <li>
              de tenter d'accéder sans autorisation à des moyens informatiques ou organisationnels mis en œuvre en relation avec le Site et susceptibles de perturber l'accès ou l'utilisation du Site;
            </li>
            <li>
              de porter atteinte aux droits de propriété intellectuelle d’OSTREON et/ou de revendre ou de tenter de revendre les Services à des tiers ;
            </li>
            <li>
              de vendre, copier, reproduire, louer, prêter, distribuer, transférer ou concéder, sous-licence, tout ou partie des contenus figurant sur le Site ou de décompiler, désassembler, modifier, afficher sous forme lisible par l’Utilisateur, tenter de découvrir tout code source ou utiliser tout logiciel activant ou comprenant tout ou partie du Site ou de l’Application;
            </li>
            <li>
              de procéder à toute forme d’utilisation des Services de quelque façon que ce soit, aux fins de conception, réalisation, diffusion ou commercialisation des Services faisant concurrence à ceux d’OSTREON.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            6. Services fournis par OSTREON
          </strong>
        </p>

        <p>
          <strong>Description des Services.</strong>
          OSTREON propose un service en ligne, en mode SaaS, permettant aux Clients l’envoi, et le cas échéant la transmission, de manière automatisée et sécurisée, des Actifs sélectionnés par le Client, selon des critères et aux Bénéficiaires définis de manière exclusive par le Client. Les Services fournis par OSTREON sont basés sur le « zero trust and zero knowledge » : les Actifs sont envoyés de manière chiffrée sur les serveurs d’OSTREON et ne peuvent donc être lus par OSTREON.
        </p>
        <p>
          <strong>Accès / disponibilité des Services.</strong>
          OSTREON s’engage à ce que les Services soient accessibles 24h sur 24 et 7j/7. Compte tenu des aléas techniques inhérents à l’utilisation du réseau Internet, OSTREON exclut toute responsabilité en cas d’éventuels ralentissements ou d’indisponibilité des Services. En outre, OSTREON se réserve le droit de suspendre de manière totale ou partielle l’accès aux Services afin de réaliser des opérations de maintenance ou d’évolution des Services notamment. Lorsque cela est possible, notamment en cas de planification prévue d’une opération de maintenance, OSTREON en informe au préalable le Client par tous moyens. Dans le cadre de son obligation de moyen, OSTREON fournit ses meilleurs efforts afin de réduire au maximum l’indisponibilité des Services.
        </p>
        <p>
          <strong>Mesures de sécurité.</strong>
          OSTREON met en place des mesures techniques et organisationnelles, énumérées dans la Politique de confidentialité, de nature à empêcher tout accès frauduleux aux Actifs. Le Client demeure responsable de la protection et de la sauvegarde des Actifs.
        </p>

        <p className={styles.title}>
          <strong>
            7. Accès aux Services - Compte Client
          </strong>
        </p>

        <p>
          <strong>Création d’un Compte Client.</strong>
          L’accès et l’utilisation des Services requiert la création préalable d’un Compte Client. Aux fins de créer un Compte Client, le Client doit notamment renseigner les informations suivantes : adresse électronique ; prénom ; nom. Le Client doit par ailleurs définir un mot de passe et accepter les Conditions Générales ainsi que la Politique de confidentialité. Le Client finalise la création de son Compte Client en confirmant son adresse électronique au moyen d’un lien d’activation qui lui sera adressé à ladite adresse électronique. Un Compte Client ne peut être transféré, cédé ou partagé. Le Compte Client n’est pas partagé avec les Bénéficiaires.
        </p>
        <p>
          <strong>Accès au Compte Client.</strong>
          Une fois le Compte Client créé, le Client se connecte à son Compte Client en se rendant sur la page de connexion et en renseignant son adresse électronique, son mot de passe préalablement créé et un code à usage unique (OTP). Il appartient au Client de prendre les mesures nécessaires à la préservation de la confidentialité de ses informations de connexion à son Compte Client.
        </p>
        <p>
          <strong>
            Utilisation du Compte Client.
          </strong>
          L’ensemble des Services sont fournis par l’intermédiaire du Compte Client, qui offre notamment au Client la possibilité de paramétrer ses Actifs, ses Bénéficiaires et les Notifications. Le Client est seul responsable des choix opérés s’agissant des Bénéficiaires, de l’ordre de priorité des Bénéficiaires, des Actifs et des Notifications.
        </p>
        <p>
          <strong>Accès aux Actifs par les Bénéficiaires.</strong>
          Il relève de la seule responsabilité du Client de définir (i) les Bénéficiaires et de leur attribuer un niveau de priorité 1 ou 2 et (ii) les Facilitateurs.  Si le Client ne répond plus à ses Notifications, un email d’activation sera adressé aux Bénéficiaires concernés à une fréquence définie correspondant à environ tous les trois (3) jours, puis environ tous les quatorze (14) jours pendant une période de six (6) mois, sauf si le Bénéficiaire se connecte avec succès à l’Application OSTREON au cours de cette période. A l’issue de cette période de six (6) mois, l’accès du Bénéficiaire est révoqué.
        </p>
        <p>
          Il relève de la seule responsabilité du Bénéficiaire de se connecter à l’Application dès réception de l’email d’activation. L’accès aux Actifs par les Bénéficiaires s’effectue via un portail dédié sur l’Application OSTREON et est conditionné à l’acceptation pleine et entière des présentes CG. Le Bénéficiaire aura accès aux Actifs selon les choix opérés par le Client, mais n’aura pas accès au Compte Client.
        </p>
        <p>
          En aucun cas la responsabilité d’OSTREON ne pourra être recherchée en cas d’absence de connexion à l’Application, d’envoi et/ou de transmission des Actifs au Bénéficiaire, imputable en tout ou partie au Client ou au Bénéficiaire, notamment en raison d’une absence d’activation de son accès par le Bénéficiaire, à un classement des mails adressés par OSTREON comme spams, à une absence de vérification des spams ou à une erreur du Client dans les informations relatives aux Bénéficiaires.
        </p>

        <p className={styles.title}>
          <strong>
            8. Souscription aux Services – Durée - Résiliation
          </strong>
        </p>

        <p>
          <strong>Offre d’essai.</strong>
          La durée de l’Offre d’essai est limitée à trois (3) mois maximum, pendant laquelle les Services d’OSTREON peuvent être utiliser sans avoir à souscrire à un abonnement. Un même Utilisateur ne peut bénéficier que d’une seule et unique Offre d’essai.
        </p>
        <p>
          Sauf mention contraire dans les CG et à l’exception de l’article 9, les dispositions applicables au Client sont opposables au Client bénéficiant d’une Offre d’essai.
        </p>
        <p>
          A l’issue de l’Offre d’essai et en l’absence de souscription à un abonnement auprès d’OSTREON, les Services d’OSTREON ne seront plus accessibles. Le Client conserve la possibilité de se connecter à son Compte Client, d’accéder ou de supprimer ses Actifs mais il sera dans l’impossibilité d’effectuer toute autre action, notamment (i) de modifier ou d’ajouter des Actifs supplémentaires et (ii) d’activer ou de modifier le système de Notifications.
        </p>
        <p>
          A l’issue d’une période de vingt-quatre (24) mois d’inactivité à compter de la fin de l’Offre d’essai, l’accès au Compte Client sera révoqué et toutes les données associées, y compris les Actifs, seront supprimées. Cette révocation est précédée de l’envoi par OSTREON de mails d’information sur la révocation à venir. L’Utilisateur dispose à tout moment, que ce soit pendant ou postérieurement à l’Offre d’essai, de la faculté de souscrire un abonnement avec la même adresse électronique, conformément aux CG en vigueur au jour de la souscription.
        </p>
        <p>
          <strong>Souscription à un abonnement.</strong>
          Les Services sont proposés par OSTREON sous la forme d’abonnements conclus pour des durées variables selon la formule choisie. Le Client ne peut avoir qu’un seul abonnement actif à un moment donné. La souscription à un abonnement est définitive et le contrat réputé formé, dès lors que le Client a reçu confirmation de sa souscription.
        </p>
        <p>
          <strong>Durée.</strong>
          Le Client dispose de la faculté de choisir la durée de son abonnement parmi l’une des durées proposées par OSTREON.
        </p>
        <p>
          <strong>Renouvellement automatique des abonnements.</strong>
          Tous les abonnements sont automatiquement renouvelables. Un (1) mois avant la date d’anniversaire de l’abonnement, un courriel de rappel est envoyé au Client, lui recommandant de se connecter et de confirmer ses informations de paiement. Un second courriel de rappel est envoyé une (1) semaine avant la date d’anniversaire de l’abonnement.
        </p>
        <p>
          <strong>Changement d’abonnement.</strong>
          Le Client dispose de la possibilité de souscrire à un abonnement d’une durée supérieure. Dans cette hypothèse, la durée supplémentaire souscrite sera ajoutée à la durée de l’abonnement précédemment souscrit. Si le Client souhaite être remboursé de la partie de son précédent abonnement qu’il n’aurait pas utilisé, il doit contacter OSTREON à l’adresse suivante: <a href="mailto:support@ostreon.io">support@ostreon.io</a>.
        </p>
        <p>
          <strong>
            Droit de rétractation du Client (hors Offre d’essai).
          </strong>
          En application des articles L221-18 et suivants du Code de la consommation, le Client dispose d’un droit de rétractation qu’il peut exercer, sans avoir à justifier de motifs, dans un délai de quatorze (14) jours francs à compter de la souscription à un abonnement. Lorsque le délai de quatorze (14) jours expire un samedi, un dimanche ou un jour férié ou chômé, il est prorogé jusqu'au premier jour ouvrable suivant. Le Client doit exprimer sa volonté à OSTREON de se rétracter de manière dénuée d’ambigüité (modèle de formulaire de rétractation en Annexe 1, à l’adresse suivante: <a href="mailto:support@ostreon.io">support@ostreon.io</a>. OSTREON procédera à un remboursement dans les quatorze (14) jours suivant la notification de rétractation sur le même mode de règlement que celui utilisé pour le règlement de l’abonnement.
        </p>
        <p>
          <strong>Garantie légale de conformité du Client (hors Offre d’essai).</strong>
          Si le Service fourni par OSTREON n’est pas conforme au Service auquel le Client a souscrit, ce dernier dispose de la possibilité d’exercer une réclamation auprès d’OSTREON pendant un délai de deux (2) ans conformément aux articles L.224-25-12 et suivants du Code de la consommation reproduits en Annexe 2.
        </p>
        <p>
          <strong>Résiliation par le Client (hors Offre d’essai).</strong>
          Le Client dispose de la faculté de mettre fin à son abonnement à tout moment et sans frais depuis son Compte Client ou en adressant une demande à l’adresse suivante <a href="mailto:support@ostreon.io">support@ostreon.io</a>. La résiliation doit intervenir au moins sept (7) jours avant la prochaine date de paiement prévue. Si l’abonnement est résilié dans les délais, le renouvellement automatique sera désactivé. Le Client pourra continuer à bénéficier des Services d’OSTREON jusqu’à la date d’échéance initialement prévue de l’abonnement. Aucun remboursement ne sera effectué.
        </p>
        <p>
          <strong>Conséquences de la fin du contrat pour le Client (hors Offre d’essai).</strong>
          La fin de l’abonnement entraîne l’arrêt des Services concernés par l’abonnement le dernier jour de la période d’abonnement payée. Le Client pourra alors toujours se connecter à son Compte Client et accéder ou supprimer ses Actifs mais il sera dans l’impossibilité (i) de modifier ou d’ajouter des Actifs supplémentaires et (ii) de modifier ou d’activer le système de Notifications. A l’issue d’une période de vingt-quatre (24) mois d’inactivité, le Compte Client et les Actifs associés au Compte Client seront supprimées.
        </p>
        <p>
          Toutes les dispositions des présentes qui, en raison de leur nature, sont destinées à survivre à l’échéance de l’abonnement, survivront à cette échéance, quelle qu’en soit la cause.
        </p>

        <p className={styles.title}>
          <strong>
            9. Conditions financières
          </strong>
        </p>

        <p>
          <strong>Prix.</strong>
          Les prix des abonnements sont affichés directement sur le Site, en euros toutes taxes comprises et sont indiqués de manière claire et précise avant la conclusion du contrat.
        </p>
        <p>
          <strong>
            Modification des prix des Produits.
          </strong>
          OSTREON se réserve le droit de modifier, à tout moment et sans préavis, le prix des abonnements proposés. Le prix applicable sera celui indiqué au jour de la souscription de cet abonnement par le Client.
        </p>
        <p>
          <strong>Modalités de facturation.</strong>
          L’abonnement est facturé intégralement et de manière annuelle au moment de la souscription audit abonnement. Une facture sera automatiquement envoyée au Client (hors Offre d’essai) par courrier électronique à la suite du règlement de l’abonnement. En l’absence de réception de cette facture, le Client est invité à envoyer une demande à l’adresse suivante: <a href="mailto:support@ostreon.io">support@ostreon.io</a>.
        </p>
        <p>
          <strong>Modalités de règlement.</strong>
          Le Client peut régler l’abonnement par l’un des modes de paiement suivants:
          <ul>
            <li>
              Carte bancaire;
            </li>
            <li>
              Google Pay;
            </li>
            <li>
              PayPal.
            </li>
          </ul>
        </p>
        <p>
          Le prestataire de service de paiement et de facturation est Stripe.
        </p>
        <p>
          Dans le cadre de la souscription d’un abonnement « sans limitation de durée », le Client (hors Offre d’essai) qui souhaite effectuer un paiement par virement bancaire peut contacter OSTREON à l’adresse suivante <a href="mailto:support@ostreon.io">support@ostreon.io</a> pour obtenir les coordonnées bancaires d’OSTREON. Le Client devra indiquer son identifiant dans la section « commentaire » du virement bancaire et informer OSTREON une fois le virement bancaire effectué, en fournissant l’identifiant de sa transaction. Le Client doit ensuite attendre l’approbation pendant un délai maximum de sept (7) jours jusqu’à réception du paiement.
        </p>

        <p className={styles.title}>
          <strong>
            10. Actifs
          </strong>
        </p>

        <p>
          Les Actifs étant préalablement chiffrés, OSTREON ne peut accéder en aucun cas au contenu des Actifs.
        </p>
        <p>
          Le Client est et demeure propriétaire des Actifs.
        </p>
        <p>
          Le Client garantit être titulaire des droits ou avoir obtenu les autorisations nécessaires lui permettant d’utiliser les Actifs et de transmettre les Données Personnelles, notamment celles des Bénéficiaires, nécessaires à l’envoi des Notifications. En conséquence, le Client dégage OSTREON de toute responsabilité en cas de non-conformité des Actifs et/ou des informations transmises, en ce inclus les Données Personnelles, aux lois et règlements, à l’ordre public ou encore aux besoins du Client.
        </p>
        <p>
          Sous réserve des dispositions applicables en matière de confidentialité, le Client concède à OSTREON une licence non-exclusive et gratuite d’utilisation des Actifs dont le seul objet est l’exécution du contrat entre le Client et OSTREON.
        </p>
        <p>
          OSTREON s’engage à mettre en œuvre les moyens techniques appropriés pour assurer la sécurité et la confidentialité des Actifs. OSTREON met également en place les mesures techniques et organisationnelles de nature à empêcher tout accès ou utilisation frauduleux aux Actifs et à prévenir le Client de toutes pertes, altérations ou destructions des Actifs.
        </p>
        <p>
          Le Client demeure responsable de la protection et de la sauvegarde des Actifs. Il lui appartient de réaliser des sauvegardes régulières de ses Actifs sur tout moyen à sa disposition. OSTREON exclut toute responsabilité à cet égard.
        </p>
        <p>
          Le Client est seul responsable de la qualité, de l’exactitude, de l’intégrité, de la licéité ainsi que de la pertinence des Actifs. OSTREON n’a aucunement accès au contenu des Actifs et ne pourra en aucun cas procéder à d’éventuelles restaurations de tout ou partie des Actifs en cas de destruction, disparition ou altération inopinée  sur demande du Client.
        </p>
        <p>
          Le Client garantit OSTREON à première demande contre tout préjudice qui résulterait de sa mise en cause par un tiers pour une violation de cette garantie.
        </p>
        <p>
          La notion d’Actifs ne s’étend pas aux informations relatives aux Clients, à ses Bénéficiaires ou ses Facilitateurs, communiquées par le Client dans le cadre de son utilisation des Services et nécessaires à la création et gestion administrative de son Compte Client ou de son abonnement (exemple : données d’identification, données de contact, données comptables, factures).
        </p>

        <p className={styles.title}>
          <strong>
            11. Responsabilité
          </strong>
        </p>

        <p>
          Les Services proposés par OSTREON sont fournis en l’état. OSTREON peut s’exonérer de tout ou partie de sa responsabilité en apportant la preuve que l’inexécution ou la mauvaise exécution des Services est imputable soit au Client, soit au fait imprévisible et insurmontable d’un tiers. OSTREON ne sera pas considéré comme responsable ni défaillante pour tout retard ou inexécution consécutif à la survenance d’un cas de force majeure tel qu’habituellement reconnu par la jurisprudence française.
        </p>
        <p>
          L’Utilisateur est seul responsable des équipements et de la connexion Internet utilisés pour accéder aux Services. L'impossibilité totale ou partielle d'utiliser les Services notamment pour cause d'incompatibilité du matériel du Client ou des Bénéficiaires ne peut donner lieu à aucun dédommagement, remboursement ou mise en cause de la responsabilité d’OSTREON, sauf dans le cas de non-conformité et/ou de défectuosité prévu par le Code de la consommation.
        </p>
        <p>
          Tout Utilisateur est seul responsable de l’utilisation du Site. Le Client est seul responsable du choix et de l’utilisation des Services, du choix et de l’exactitude des informations relatives aux Bénéficiaires ainsi que du choix et de la conservation des Actifs. Le Bénéficiaire, ayant eu accès aux Actifs, est seul responsable de ces Actifs et de leur utilisation. OSTREON exclut toute responsabilité quant au contenu de ces Actifs.
        </p>
        <p>
          OSTREON est un éditeur de logiciel SaaS et ne fournit aucune prestation de conseil de quelque forme et de quelque nature que ce soit. En aucun cas, l’utilisation de l’Application ou des Services ne garantit la conformité des Actifs et du choix des Bénéficiaires à la règlementation applicable en matière de droit civil et de droit des successions, ce qui relève de la responsabilité du Client.  La responsabilité d’OSTREON ne pourra donc être engagée sur ce fondement. Il est rappelé au Client et aux Bénéficiaires qu’ils peuvent se faire accompagner par tout tiers professionnel de son choix, en ce inclus les professions règlementées (avocat, notaire, etc.), afin d’opérer les choix les plus adaptés à la préservation de ses intérêts. Ces professionnels peuvent notamment être désignés en tant que Facilitateurs dans le cadre des Services.
        </p>
        <p>
          Le Client s’assure et vérifie le caractère exact et complet des renseignements et informations renseignés lors de la création de son Compte Client et lors de l’utilisation des Services. OSTREON exclut toute responsabilité en cas d’éventuelles erreurs de saisie du Client ou absence de mise à jour des Actifs, des Notifications et des informations relatives au Client ou à ses Bénéficiaires, en ce inclus les Données Personnelles. En particulier, OSTREON s’exonère de toute responsabilité en cas de carence, d’erreur ou d’inexactitude imputable au Client et portant sur les Actifs, les Notifications ou les Bénéficiaires.
        </p>
        <p>
          OSTREON exclut toute responsabilité en cas d’absence de réponse de la part des Bénéficiaires aux Notifications.
        </p>
        <p>
          En cas d’ouverture d’une procédure collective, le Client reconnaît que le maintien de la fourniture des Services ne dépendra pas de la volonté d’OSTREON mais de l’administrateur désigné et ne pourra donc pas rechercher la responsabilité d’OSTREON à cet égard.
        </p>

        <p className={styles.title}>
          <strong>
            12. Droits de propriété intellectuelle
          </strong>
        </p>

        <p>
          <strong>
            Propriété intellectuelle d’OSTREON sur le contenu du Site.
          </strong>
          Le Site et l’ensemble des éléments inclus ou accessibles sur le Site (textes, images, schémas, graphismes, marques, logos, dessins, photographies, bases de données, logiciels, etc.), en ce inclus sa structure, sont protégés par le droit de la propriété intellectuelle et soumis aux lois et réglementations applicables en la matière. Ils sont et demeurent la propriété exclusive d’OSTREON. Les droits y afférent sont réservés pour tous les pays et pour la durée des droits de propriété intellectuelle.
        </p>
        <p>
          Toute représentation ou reproduction, traduction, adaptation, arrangement de tout ou partie du Site ou des éléments inclus ou accessibles sur le Site effectuée sans le consentement préalable et écrit d’OSTREON est interdite. L’absence d’engagement d’une action contre tout Utilisateur procédant à un acte de contrefaçon ne peut être considérée comme une acceptation de la part d’OSTREON de ladite utilisation.
        </p>
        <p>
          Tout usage donnant prise aux droits précités ne peut avoir lieu qu’avec l’autorisation expresse, écrite et préalable d’OSTREON, en soumettant une demande écrite par mail à l’adresse <a href="mailto:support@ostreon.io">support@ostreon.io</a>. L’absence de réponse d’OSTREON à cette demande écrite ne peut valoir autorisation.
        </p>
        <p>
          <strong>
            Droit d’utilisation de l’Application OSTREON.
          </strong>
          OSTREON est et demeure seul titulaire de tous les droits de propriété intellectuelle sur l’Application, sur les Services ainsi que sur l’ensemble des documents, de toutes natures communiqués sur le Site ou dans le cadre des présentes par OSTREON.
        </p>
        <p>
          Aux fins d’utilisation des Services, OSTREON accorde au Client le droit non exclusif, non transmissible, non cessible, sans droit de sous-licence, d’accéder et d’utiliser l’Application OSTREON, dans les limites décrites dans les présentes.
        </p>
        <p>
          Le Client s’engage à utiliser l’Application OSTREON et les Services pour son usage propre et en tant qu’utilisateur final, à l’exclusion de toutes fins commerciales. Le Client s’engage à ne pas:
          <ul>
            <li>
              copier ou reproduire, diffuser, modifier, adapter l’Application en tout ou partie par n’importe quel moyen et sous n’importe quelle forme;
            </li>
            <li>
              traduire ou transcrire l’Application OSTREON dans toute autre langue ou de lui adjoindre tout objet non conforme à sa spécification;
            </li>
            <li>
              décompiler ou procéder à de la rétro-ingénierie du code de l’Application au-delà de la limite autorisée par la loi;
            </li>
            <li>
              distribuer, commercialiser, concéder, céder, transférer de quelque manière que ce soit, à titre onéreux ou à titre gratuit, l’Application ou les Services ou une application ou des services similaires à ceux proposés par OSTREON;
            </li>
            <li>
              autoriser l’accès et l’utilisation de l’Application par une personne autre que le Bénéficiaire ou le Facilitateur ou tenter d’accéder de manière non autorisée à l’Application ou aux Services;
            </li>
            <li>
              conférer quelque droit et constituer quelque garantie, sûreté ou privilège que ce soit sur l’Application ou sur les Services au profit de tiers;
            </li>
            <li>
              intégrer l’Application dans d’autres œuvres informatiques ou numériques ou dans des produits;
            </li>
            <li>
              introduire dans l’Application et les Services des virus informatiques, chevaux de Troie ou tout autre code ou logiciel conçus pour entraver, fausser, interrompre, détruire ou limiter le fonctionnement normal ou les fonctionnalités de l’Application ou des Services ou de manière général tout logiciel, ordinateur, serveur ou outil de communications électroniques;
            </li>
            <li>
              tenter de pirater, de mener des tests d’intrusion , des actions de reconnaissance, des exercices d’équipe rouge, de scanner, de surveiller, de scrapper, d’indexer, d’abuser ou d’effectuer toute action qui pourrait être intrusive (bruyante ou silencieuse) à toute partie de l’Application sans l’autorisation écrite d’OSTREON.
            </li>
          </ul>
        </p>
        <p>
          Les dispositions des présentes ne sauraient être analysées comme la cession d’un quelconque droit de propriété intellectuelle au bénéfice du Client et plus largement de l’Utilisateur. Le Client s’engage à respecter l’ensemble des droits de propriété intellectuelle d’OSTREON et, le cas échéant, à apposer les mentions relatives à la propriété ou aux revendications de propriété d’OSTREON. Le Client se porte fort du respect des droits de propriété intellectuelle d’OSTREON par le Bénéficiaire. Tout manquement aux dispositions du présent article est susceptible de conduire à la résiliation de plein droit de la fourniture des Services par OSTREON ou à l’arrêt de l’Offre d’essai.
        </p>
        <p>
          Le Client informera immédiatement OSTREON de toute reproduction, imitation ou autre contrefaçon des Services dont il pourrait avoir connaissance.
        </p>
        <p>
          Les dispositions des présentes sont opposables aux Bénéficiaires dans le cadre de leur utilisation de l’Application OSTREON via le portail d’accès dédié.
        </p>

        <p className={styles.title}>
          <strong>
            13. Confidentialité
          </strong>
        </p>

        <p>
          Pendant toute la durée du contrat, les Parties s’engagent à préserver le caractère confidentiel de toute Information confidentielle.
        </p>
        <p>
          Les Parties n'auront aucune obligation et ne seront soumises à aucune restriction eu égard à toutes les informations dont elles peuvent apporter la preuve qu'elles sont entrées dans le domaine public à la date de leur divulgation, qu’elles étaient déjà connues de l’autre Partie, qu'elles ont été reçues d'un tiers autorisé à les divulguer, de manière licite, sans restriction ni violation des présentes ou encore qu’une Partie est tenue de communiquer en vertu d’une obligation législative ou règlementaire, d’une décision de justice ou sur la demande d’une autorité publique.
        </p>

        <p className={styles.title}>
          <strong>
            14. Protection des Données Personnelles
          </strong>
        </p>

        <p>
          <strong>Responsable du traitement.</strong>
          En sa qualité de responsable du traitement, OSTREON s’engage à respecter la Règlementation relative à la protection des Données Personnelles conformément à la Politique de confidentialité.
        </p>
        <p>
          <strong>Sous-traitance.</strong>
          Dans le cadre de la fourniture des Services et à l’exception des Utilisateurs personnes physiques agissant dans le cadre d'une activité strictement personnelle ou domestique, OSTREON est susceptible de mettre en œuvre, en qualité de sous-traitant, pour le compte du Client, agissant en qualité de responsable de traitement les opérations de traitement de Données Personnelles définies ci-après.
        </p>

        <p className={styles.title}>
          <strong>
            14.1. Description du traitement
          </strong>
        </p>

        <p>
          OSTREON est autorisé à traiter pour le compte du Client les Données Personnelles nécessaires pour fournir les Services, étant précisé que:
          <ul>
            <li>
              la nature et la finalité du traitement sont : la fourniture des Services. Si des traitements relatifs à d’autres finalités sont confiés par le Client à OSTREON, le Client devra le spécifier par écrit;
            </li>
            <li>
              les catégories de personnes concernées sont les Utilisateurs, les Bénéficiaires, les Facilitateurs;
            </li>
            <li>
              les Données Personnelles traitées sont : nom, prénom, adresse mail, adresse postale, des informations d’ordre économique et financier (à l’exception des Offres d’essai : date et heure du paiement, montant, mode de paiement, formule d’abonnement, statut de paiement, informations de facturation;
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            14.2. Obligations d’OSTREON en qualité de sous-traitant
          </strong>
        </p>

        <p>
          OSTREON s'engage à:
          <ul>
            <li>
              traiter les Données Personnelles uniquement pour la ou les seule(s) finalité(s) qui fait/font l’objet de la sous-traitance;
            </li>
            <li>
              traiter les Données Personnelles conformément à la description des Services. Si OSTREON considère qu’une instruction constitue une violation du RGPD ou de toute autre disposition du droit de l’Union Européenne ou du droit des Etats membres relative à la protection des Données Personnelles, il en informe immédiatement le Client. Un refus écrit et documenté de la part d’OSTREON n’ouvre pas droit au Client de résilier le contrat, sauf pour ce dernier à engager sa responsabilité à l’égard d’OSTREON. En outre, si OSTREON est tenu de procéder à un transfert de Données Personnelles vers un pays tiers ou à une organisation internationale, en vertu du droit de l’Union Européenne ou du droit de l’Etat membre auquel il est soumis, il doit informer le Client de ses obligations juridiques avant le traitement, sauf si le droit concerné interdit une telle information pour des motifs importants d'intérêt public;
            </li>
            <li>
              garantir la confidentialité et la sécurité des Données Personnelles traitées;
            </li>
            <li>
              veiller à ce que les personnes autorisées à traiter les Données Personnelles:
              <ul>
                <li>
                  soient uniquement les personnes dont les fonctions nécessitent l'accès aux Données Personnelles pour la stricte exécution des tâches confiées. OSTREON s'engage à prendre ou à adapter toute mesure interne en termes d'organisation interne ou de techniques pour limiter toute diffusion de données personnelles à d'autres personnes;
                </li>
                <li>
                  s’engagent à respecter la confidentialité ou soient soumises à une obligation légale appropriée de confidentialité;
                </li>
                <li>
                  reçoivent la formation nécessaire en matière de protection des données à caractère personnel. OSTREON se porte fort du respect par ses employés de ses engagements au titre du présent article;
                </li>
              </ul>
            </li>
            <li>
              prendre en compte, s’agissant de ses outils, produits, applications ou services, les principes de protection des données dès la conception et de protection des données par défaut.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            14.3. Sous-traitance
          </strong>
        </p>

        <p>
          Le Client autorise OSTREON à faire appel à des sous-traitants (ci-après le ou les '<strong>Sous-traitant(s) ultérieur(s)</strong>') pour mener des activités de traitement spécifiques.
        </p>
        <p>
          OSTREON s’assure que le Sous-traitant ultérieur présente les garanties suffisantes quant à la mise en œuvre de mesures techniques et organisationnelles appropriées de manière à ce que le traitement réponde aux exigences du RGPD et aux engagements pris dans les présentes CG.
        </p>
        <p>
          OSTREON s’engage à faire appel des Sous-traitants : (i) établi dans un pays de l’Union Européenne ou de l’Espace Economique Européen (EEE) ou (ii) établi dans un pays disposant d’un niveau de protection suffisant par décision de la Commission Européenne au regard de la règlementation applicable en matière de protection des données personnelles ou (iii) avec lesquels OSTREON a recours des clauses contractuelles types ou (iv) disposant des garanties appropriées en application de l'article 46 du RGPD.
        </p>
        <p>
          Les Données personnelles sont hébergées auprès des hébergeurs sous-traitants d’OSTREON, STRIPE et AWS sur des serveurs situés exclusivement sur le territoire de l’Union Européenne. La liste complète des sous-traitants d’OSTREON est fournie sur demande écrite du Client. OSTREON informe dans les meilleurs délais le Client de tout changement envisagé concernant l’ajout ou le remplacement d’autres sous-traitants. Le Client dispose de dix (10) jours ouvrés à compter de la réception de cette notification pour formuler des objections. L’absence d’objection pendant ce délai équivaut à une acceptation de la part du Client. En présence d’objections, OSTREON a la possibilité de formuler des éléments de réponse. En cas de désaccord, OSTREON pourra suspendre l’accès aux Services jusqu’à ce qu’un accord soit trouvé ou jusqu’à la résiliation du contrat par le Client ou par OSTREON.OSTREON demeure pleinement responsable devant le Client de l’exécution par l’autre Sous-traitant de ses obligations. En aucun cas OSTREON ne sera tenue pour responsable en cas d’absence de transparence ou de transmission d’informations inexactes par le Sous-traitant ultérieur.
        </p>

        <p className={styles.title}>
          <strong>
            14.4. Droit d’information des personnes concernées
          </strong>
        </p>

        <p>
          Il appartient au Client de fournir l’information aux personnes concernées par les opérations de traitement au moment de la collecte des données.
        </p>

        <p className={styles.title}>
          <strong>
            14.5. Exercice des droits des personnes concernées
          </strong>
        </p>

        <p>
          Dans la mesure du possible, OSTREON aide le Client à s’acquitter de son obligation de donner suite aux demandes d’exercice des droits des personnes concernées : droit d’accès, de rectification, d’effacement et d’opposition, droit à la limitation du traitement, droit à la portabilité des données, droit de ne pas faire l’objet d’une décision individuelle automatisée (y compris le profilage).
        </p>
        <p>
          Lorsque les personnes concernées exercent auprès d’OSTREON des demandes d’exercice de leurs droits, OSTREON adressera ces demandes dès réception par courrier électronique à l’adresse mail communiquée par le Client.
        </p>

        <p className={styles.title}>
          <strong>
            14.6. Notification des violations des Données Personnelles
          </strong>
        </p>

        <p>
          OSTREON notifie au Client toute violation de Données Personnelles dans un délai maximum de quarante-huit (48) heures après en avoir pris connaissance, par email. Cette notification est accompagnée de toute documentation utile afin de permettre au Client, si nécessaire, de notifier cette violation à l’autorité de contrôle compétente.
        </p>

        <p className={styles.title}>
          <strong>
            14.7. Mesures de sécurité
          </strong>
        </p>

        <p>
          OSTREON s’engage à mettre en œuvre les mesures de sécurité techniques et organisationnelles pour préserver la sécurité et la confidentialité des Données personnelles. La liste des mesures de sécurité mises en place par SOTREON est disponible sur demande écrite de la part du Client.
        </p>

        <p className={styles.title}>
          <strong>
            14.8. Sort des Données personnelles – Réversibilité
          </strong>
        </p>

        <p>
          Au terme du contrat, OSTREON met à disposition du Client toutes les Données personnelles transmises sous un format CSV et les supprime, sous réserve de ses obligations légales et règlementaires.
        </p>

        <p className={styles.title}>
          <strong>
            14.9. Registre des catégories d’activités de traitement
          </strong>
        </p>

        <p>
          OSTREON déclare tenir par écrit un registre de toutes les catégories d’activités de traitement effectuées pour le Client.
        </p>

        <p className={styles.title}>
          <strong>
            14.10. Documentation
          </strong>
        </p>

        <p>
          Sur demande expresse et écrite du Client, OSTREON met à la disposition du Client, dans la limite d’une (1) demande par an moyennant un préavis de dix (10) jours, la documentation nécessaire pour démontrer le respect de toutes ses obligations et pour permettre la réalisation d'audits, y compris des inspections, par le responsable du traitement ou un autre auditeur qu'il a mandaté, et contribuer à ces audits.
        </p>

        <p className={styles.title}>
          <strong>
            14.11. Obligations du Client à l’égard d’OSTREON
          </strong>
        </p>

        <p>
          Le Client s’engage à:
          <ul>
            <li>
              Communiquer uniquement des Données Personnelles collectées de manière licite auprès des personnes concernées;
            </li>
            <li>
              Fournir à OSTREON les Données Personnelles nécessaires pour l’exécution de sa mission en qualité de sous-traitant;
            </li>
            <li>
              Documenter par écrit toute instruction concernant le traitement des Données Personnelles par OSTREON;
            </li>
            <li>
              Veiller, au préalable et pendant toute la durée du traitement, au respect des obligations prévues par le RGPD de la part d’OSTREON;
            </li>
            <li>
              Superviser le traitement, y compris réaliser les audits et les inspections auprès d’OSTREON.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            15. Renvoi vers des sites tiers/boutons de partage
          </strong>
        </p>

        <p>
          Le Site peut contenir des liens vers d’autres sites non édités ni contrôlés par OSTREON, qui ne pourra être tenue pour responsable du fonctionnement, du contenu ou de tout élément présent ou obtenu par l’intermédiaire de ces sites.
        </p>
        <p>
          La mise en place de tels liens ou la référence à toutes informations, articles ou services fournis par une tierce personne, ne peut et ne doit pas être interprétée comme un aval exprès ou tacite, par OSTREON, de ces sites et de ces éléments ni de leurs contenus.
        </p>
        <p>
          Le Client est invité à se reporter et à lire attentivement les règles applicables à l’utilisation des informations communiquées sur ces sites. OSTREON ne pouvant procéder au contrôle permanent de ces liens sur le Site, elle ne pourra être tenue responsable pour quelque raison que ce soit du contenu de ces sites.
        </p>
        <p>
          Toutes questions ou commentaires en rapport avec un autre site devront être adressés aux opérateurs de ces sites. Aucun lien vers le Site n’est autorisé sans l’autorisation expresse préalable et écrite d’OSTREON.
        </p>
        <p>
          Les boutons de partage des réseaux sociaux présents sur le Site permettent de partager des contenus du Site au travers des boutons « Partager », « J'aime », des réseaux sociaux tels que Facebook, X (ex Twitter), LinkedIn, Instagram, etc. Ces réseaux sociaux peuvent collecter des Données personnelles relatives à la navigation par le Client et les associer aux Données personnelles auxquelles ils ont accès, conformément à leurs propres conditions d’utilisation et politiques de confidentialité. OSTREON n’exerce aucun contrôle et exclut toute responsabilité s’agissant de l’utilisation des Données personnelles de l’Utilisateur par ces réseaux sociaux.
        </p>

        <p className={styles.title}>
          <strong>
            16. Assurance
          </strong>
        </p>

        <p>
          OSTREON déclare être assurée auprès d’une compagnie d’assurance notoirement solvable, pour toutes les conséquences dommageables des actes dont elle pourrait être tenue responsable en vertu des CG, et s’engage à maintenir à jour le règlement des primes correspondantes.
        </p>

        <p className={styles.title}>
          <strong>
            17. Sous-traitance
          </strong>
        </p>

        <p>
          Le Client accepte qu’OSTREON sous-traite une partie des Services à un ou plusieurs tiers, sous réserve que ces tiers disposent de l’expertise et des compétences nécessaires et soient soumis aux mêmes obligations qu’OSTREON.
        </p>

        <p className={styles.title}>
          <strong>
            18. Transfert
          </strong>
        </p>

        <p>
          OSTREON se réserve le droit de transférer à toute société de son choix tout ou partie des droits et obligations nées entre le Client et OSTREON au titre des CG et en informera au préalable le Client, conformément au droit applicable.
        </p>

        <p className={styles.title}>
          <strong>
            19. Convention de preuve
          </strong>
        </p>

        <p>
          L’acceptation des CG par voie électronique a, entre le Client et/ou le Bénéficiaire, d’une part, et OSTREON, d’autre part, la même valeur probante que l’accord sur support papier.
        </p>
        <p>
          De manière générale, le Client et/ou le Bénéficiaire reconnaît et accepte d’échanger avec OSTREON notamment par courrier électronique, par exemple dans le cadre des informations qui peuvent lui être adressées au cours de l’exécution des CG.
        </p>

        <p className={styles.title}>
          <strong>
            20. Non renonciation et indépendance des clauses
          </strong>
        </p>

        <p>
          La nullité d’une clause contractuelle n’entraîne pas la nullité des autres clauses des CG qui continuent à produire leurs effets.
        </p>

        <p>
          Le fait qu’OSTREON ne se prévale pas à un moment donné d’une quelconque disposition des CG ne peut être interprété comme valant renonciation à se prévaloir ultérieurement d’une quelconque disposition desdites CG.
        </p>

        <p className={styles.title}>
          <strong>
            21. Règlement des litiges et droit applicable
          </strong>
        </p>

        <p>
          <strong>Loi applicable.</strong>
          Les CG sont régies et interprétées conformément au droit français.
        </p>
        <p>
          Dispute Resolution. Prior to any legal action, with the exception of actions initiated for protective measures, the Parties agree to seek, within reasonable time limits, an amicable solution to the dispute that opposes them.
        </p>
        <p>
          <strong>Règlement des litiges.</strong>
          Préalablement à toute action en justice, exception faite des actions engagées à titre conservatoire, les Parties conviennent de rechercher, dans des délais raisonnables, une solution amiable au différend qui les oppose.
        </p>
        <p>
          <strong>Juridictions compétentes.</strong>
          A défaut de conciliation à l’issue d’un délai d’un (1) mois à compter de la survenance du différend, les Parties attribuent une compétence exclusive aux juridictions du ressort de la Cour d’appel de Paris (France), pour en connaître de toute difficulté relative à la validité, l’interprétation ou l’exécution des CG, nonobstant pluralité de défendeurs ou appel en garantie, même pour les procédures d’urgence ou conservatoires, en référé ou par requête.
        </p>
        <p>
          <strong>Réclamation d’un Client (hors Offre d’essai).</strong>
          Toute réclamation, quelle qu’en soit la nature, relative à un Service devra impérativement être présentée par l’envoi d’un courrier électronique à l’adresse suivante: <a href="mailto:complaints@ostreon.io">complaints@ostreon.io</a> ou par l’intermédiaire de la page « contactez-nous » du Site.
        </p>
        <p>
          La réclamation devra être détaillée et indiquer clairement les raisons de l’insatisfaction. OSTREON et le Client s’engage à chercher une solution amiable au règlement du litige les opposant, étant précisé que le Client dispose de la possibilité de se faire assister du conseil de son choix (association etc.).
        </p>
        <p>
          Si le Client décide de retirer sa réclamation, il reconnaît que ce retrait est définitif.
        </p>
        <p>
          <strong>Médiateur de la consommation.</strong>
          Si dans un délai d’un (1) mois à compter de ladite réclamation et en dépit des efforts déployés par OSTREON, le litige subsiste, le Client aura la possibilité de saisir le médiateur de la consommation, conformément aux articles L.612-1 et suivants du Code de la consommation.
        </p>
        <p>
          Les coordonnées du médiateur de la consommation sont les suivantes: <a href="mailto:consommation@cmap.fr">consommation@cmap.fr</a>, CMAP – Service Médiation de la consommation, 39 avenue Franklin Roosevelt, 75008 Paris. A défaut de règlement amiable à l’issue d’un délai d’un (1) mois à compter de la survenance du différend, les Parties pourront saisir les tribunaux français qui seront seuls compétents.
        </p>
        <p>
          La Commission européenne a par ailleurs mis en place une plateforme de résolution des litiges destinée à recueillir les éventuelles réclamations de consommateurs faisant suite à un achat en ligne afin de les transmettre ensuite aux médiateurs nationaux compétents. Les droits sont expliqués <a href="https://ec.europa.eu/consumers/odr/main/?event=main.consumer.rights">ici</a>, et la plateforme est accessible en cliquant <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=FR">ici</a>.
        </p>

        <div className={styles.head_title}>
          ANNEXE 1 – MODELE DE FORMULAIRE DE RETRACTATION
        </div>

        <p>
          Je/nous (*) vous notifie/notifions (*) par la présente ma/notre (*) rétractation du contrat portant sur la souscription à l’abonnement ci-dessous:
        </p>
        <p>
          Commandé le (*)/reçu le (*):
        </p>
        <p>
          Nom du (des) client(s) consommateur(s):
        </p>
        <p>
          Adresse du (des) client(s)consommateur(s):
        </p>
        <p>
          Signature du (des) client(s) consommateur(s) (uniquement en cas de notification du présent formulaire sur papier):
        </p>
        <p>
          Date:
        </p>
        <p>
          () Rayez la mention inutile.
        </p>

        <div className={styles.head_title}>
          ANNEXE 2 – GARANTIE LEGALE DE CONFORMITE
        </div>

        <p className={styles.underlined}>
          Article L.224-25-12 du Code de la consommation
        </p>

        <p>
          Le professionnel fournit un contenu numérique ou un service numérique conforme au contrat ainsi qu’aux critères énoncés à l’article L. 224-25-14.
        </p>
        <p>
          Lorsque le contrat prévoit une opération de fourniture ponctuelle du contenu numérique ou du service numérique, ou une série d’opérations de fourniture distinctes, le professionnel répond des défauts de conformité existant au moment de la fourniture et qui apparaissent dans un délai de deux ans à compter de celle-ci.
        </p>
        <p>
          Lorsque le contrat prévoit que le contenu numérique ou le service numérique est fourni de manière continue, le professionnel répond des défauts de conformité qui apparaissent au cours de la période durant laquelle celui-ci est fourni en vertu du contrat.
        </p>
        <p>
          Le délai applicable ne prive pas le consommateur de son droit aux mises à jour conformément aux dispositions de l’article L. 224-25-25.
        </p>
        <p>
          Le professionnel répond également, dans les mêmes délais, des défauts de conformité résultant de l’intégration incorrecte du contenu numérique ou du service numérique dans l’environnement numérique du consommateur lorsque celle-ci a été réalisée par le professionnel ou sous sa responsabilité, ou encore lorsque l’intégration incorrecte réalisée par le consommateur résulte de lacunes dans les instructions que le professionnel a fournies.
        </p>
        <p>
          Ce délai de garantie s'applique sans préjudice des articles 2224 et suivants du code civil. Le point de départ de la prescription de l’action du consommateur est le jour de la connaissance par ce dernier du défaut de conformité.
        </p>

        <p className={styles.underlined}>
          Article L.224-25-13 du Code de la consommation
        </p>

        <p>
          Le contenu numérique ou le service numérique est conforme au contrat s’il répond notamment, le cas échéant, aux critères suivants:
        </p>
        <p>
          1° Il correspond à la description, au type, à la quantité et à la qualité, notamment en ce qui concerne la fonctionnalité, la compatibilité, l’interopérabilité, ou toute autre caractéristique prévue au contrat;
        </p>
        <p>
          2° Il est propre à tout usage spécial recherché par le consommateur, porté à la connaissance du professionnel au plus tard au moment de la conclusion du contrat et que ce dernier a accepté;
        </p>
        <p>
          3° Il est fourni avec tous les accessoires, y compris l’emballage, les instructions d’installation, ainsi que l’assistance à la clientèle, devant être fournis conformément au contrat;
        </p>
        <p>
          4° Il est mis à jour conformément au contrat.
        </p>

        <p className={styles.underlined}>
          Article L.224-25-14 du Code de la consommation
        </p>

        <p>
          I.-En plus des critères de conformité prévus au contrat, le contenu numérique ou le service numérique est conforme s'il répond aux critères suivants:
        </p>
        <p>
          1° Il est propre à l'usage habituellement attendu d'un contenu numérique ou d'un service numérique de même type, compte tenu, s'il y a lieu, de toute disposition du droit de l'Union européenne et du droit national ainsi que de toutes les normes techniques, ou en l'absence de telles normes techniques, des codes de conduite spécifiques applicables au secteur concerné;
        </p>
        <p>
          2° Le cas échéant, il possède les qualités que le professionnel a présentées au consommateur sous forme de version d'essai ou d'aperçu, avant la conclusion du contrat;
        </p>
        <p>
          3° Il est fourni selon la version la plus récente qui est disponible au moment de la conclusion du contrat, sauf si les parties en conviennent autrement;
        </p>
        <p>
          4° En cas de fourniture continue d'un contenu numérique ou d'un service numérique pendant une période donnée, il est fourni sans interruption tout au long de cette période;
        </p>
        <p>
          5° Le cas échéant, il est fourni avec tous les accessoires et les instructions d'installation ainsi que l'assistance à la clientèle, auxquels le consommateur peut légitimement s'attendre;
        </p>
        <p>
          6° Le cas échéant, il est fourni avec les mises à jour que le consommateur peut légitimement attendre, conformément aux dispositions de l'article L. 224-25-25;
        </p>
        <p>
          7° Il correspond à la quantité, à la qualité et aux autres caractéristiques, y compris en termes de fonctionnalité, de compatibilité, d'accessibilité, de continuité et de sécurité, que le consommateur peut légitimement attendre pour des contenus numériques ou des services numériques de même type, eu égard à la nature de ces contenus ou services ainsi qu'aux déclarations publiques faites par le professionnel, par toute personne en amont dans la chaîne de transactions, ou par une personne agissant pour leur compte, y compris dans la publicité ou sur l'étiquetage.
        </p>
        <p>
          II.-Toutefois, le professionnel n'est pas tenu par toutes déclarations publiques mentionnées au dernier alinéa du I s'il démontre:
        </p>
        <p>
          1° Qu'il ne les connaissait pas et n'était légitimement pas en mesure de les connaître;
        </p>
        <p>
          2° Qu'au moment de la conclusion du contrat, les déclarations publiques avaient été rectifiées dans des conditions comparables aux déclarations initiales ; ou
        </p>
        <p>
          3° Que les déclarations publiques n'ont pas pu avoir d'influence sur la décision de contracter.
        </p>
        <p>
          III.-Le consommateur ne peut contester la conformité en invoquant un défaut concernant une ou plusieurs caractéristiques particulières du contenu numérique ou du service numérique, dont il a été spécifiquement informé qu'elles s'écartaient des critères de conformité énoncés au présent article, écart auquel il a expressément et séparément consenti lors de la conclusion du contrat.
        </p>

      </div>
    </>);
}